import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';

export default class ModalBody extends React.Component {
  static propTypes = {
    children: PropTypes.any,
    style: PropTypes.object,
  };

  static defaultProps = {
    children: null,
    style: {},
  };

  render() {
    return (
      <div className='ModalBody' style={this.props.style}>
        <div className='ModalBody-content'>{this.props.children}</div>
      </div>
    );
  }
}
